import { useLocation } from "react-router-dom";
import VisitReport from "@/components/reports/visit/VisitReport";
import ReportViewer from "@/features/reports/presentation/pages/ReportViewer";

function VisitReportViewer() {
  const location = useLocation();

  const reportUrl: string = location.state.reportUrl;

  if (reportUrl) {
    return <ReportViewer />;
  } else {
    return <VisitReport />;
  }
}

export default VisitReportViewer;
